import React, { Component } from 'react';

class NetworkIcon extends Component {
  render() {
    return (
    <a className="network-icon" href={this.props.link} target="_blank" rel="noreferrer">
        <img src={this.props.icon} alt=''></img>
    </a>
    );
  }
}

export default NetworkIcon;